import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiGatewayAxiosInstance } from "../../utils/axios";

//------------------------------------------------------------------------------------------------------------
export const getMISReportsThunk = createAsyncThunk(
    "get-all-billing-mis-reports",
    async ({ roleName, currentPage, registryId, pageSize, fromDate, toDate, orgId, timeRange, billingType }) => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/mis_server/billing/get-all-billing-mis-reports`, {
                params: {
                    roleName,
                    currentPage,
                    pageSize,
                    registryId,
                    fromDate,
                    toDate,
                    orgId,
                    timeRange,
                    billingType
                },
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response);
            }
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            throw errorMessage;
        }
    },
);

export const getActiveOrgsForResellerThunk = createAsyncThunk("get-all-active-org-by-registryId", async () => {
    try {
        const response = await apiGatewayAxiosInstance.get(`/user_management/get-all-active-org-by-registryId`, {});
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(response);
        }
    } catch (error) {
        let errorMessage = "Server not reachable.";

        if (error.response) {
            errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
        }
        throw errorMessage;
    }
});

export const getCampaignsForCampaignMIS = createAsyncThunk(
    "get-campaigns-for-campaign-mis",
    async ({ currentPage, pageSize, campaignName, botName, templateName, executedAtStartDate, executedAtEndDate, orgId, roleName }) => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/bot_management/get-campaigns-for-campaign-mis`, {
                params: {
                    currentPage,
                    pageSize,
                    campaignName,
                    botName,
                    templateName,
                    executedAtStartDate,
                    executedAtEndDate,
                    orgId,
                    roleName,
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response);
            }
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            throw errorMessage;
        }
    },
);

export const getTotalCountsForCampaignMIS = createAsyncThunk("get-total-counts-for-campaign-mis", async campaignData => {
    try {
        const response = await apiGatewayAxiosInstance.post(`/conversation_logger/get-total-counts-for-campaign-mis`, { campaignData });
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(response);
        }
    } catch (error) {
        let errorMessage = "Server not reachable.";

        if (error.response) {
            errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
        }
        throw errorMessage;
    }
});

export const getCampaignMISReportsByFilter = createAsyncThunk(
    "get-all-campaign-mis-reports-by-filter",
    async ({ currentPage, pageSize, campaignName, botName, templateName, executedAtStartDate, executedAtEndDate, orgId, roleName, registryId }) => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/mis_server/get-all-campaign-mis-reports-by-filter`, {
                params: {
                    currentPage,
                    pageSize,
                    campaignName,
                    botName,
                    templateName,
                    executedAtStartDate,
                    executedAtEndDate,
                    orgId,
                    roleName,
                    registryId,
                },
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response);
            }
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            throw errorMessage;
        }
    },
);

export const updateCampaignMISReports = createAsyncThunk("generate-campaign-mis-reports", async ({ executedAtStartDate, executedAtEndDate }) => {
    try {
        const response = await apiGatewayAxiosInstance.post(`/mis_server/generate-campaign-mis-reports`, {
            executedAtStartDate,
            executedAtEndDate,
        });
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(response);
        }
    } catch (error) {
        let errorMessage = "Server not reachable.";

        if (error.response) {
            errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
        }
        throw errorMessage;
    }
});
export const updateBillingMISReports = createAsyncThunk("generate-billing-mis-reports", async ({ startDate, endDate }) => {
    try {
        const response = await apiGatewayAxiosInstance.post(`/mis_server/billing/generate-billing-mis-reports`, {
            startDate,
            endDate,
        });
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(response);
        }
    } catch (error) {
        let errorMessage = "Server not reachable.";

        if (error.response) {
            errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
        }
        throw errorMessage;
    }
});

export const getBotMISReports = createAsyncThunk(
    "get-all-bot-mis-reports",
    async ({ roleName, registryId, currentPage, pageSize, startDate, endDate, botName, orgId, botMessageType = "all" }) => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/mis_server/bot/get-mis-reports-by-filter`, {
                params: {
                    roleName,
                    registryId,
                    currentPage,
                    pageSize,
                    startDate,
                    endDate,
                    botName,
                    orgId,
                    botMessageType
                },
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response);
            }
        } catch (error) {
            let errorMessage = "Server not reachable.";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            throw errorMessage;
        }
    },
);

export const updateBotMISReports = createAsyncThunk("generate-bot-mis-reports", async ({ executedAtStartDate, executedAtEndDate }) => {
    try {
        const response = await apiGatewayAxiosInstance.post(`/mis_server/generate-bot-mis-reports`, {
            executedAtStartDate,
            executedAtEndDate,
        });
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(response);
        }
    } catch (error) {
        let errorMessage = "Server not reachable.";

        if (error.response) {
            errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
        }
        throw errorMessage;
    }
});
